/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { JobStatus } from '../models/JobStatus';

export class JobStatusFilters {
  '_in'?: Array<JobStatus>;
  'notIn'?: Array<JobStatus>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<JobStatus>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<JobStatus>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return JobStatusFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

